import * as Scrivito from 'scrivito';
import { InfoTeaserWidgetClass } from './info-teaser-widget-class';

export const InfoTeaserWidgetComponent: React.FC<Scrivito.WidgetComponentProps> = () => {
  return <Scrivito.WidgetTag />;
};

Scrivito.provideComponent(InfoTeaserWidgetClass, InfoTeaserWidgetComponent);
